import axios from "axios";
import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import { baseUrl } from "../../config/baseUrl";
import MultiSelectDropdown from "../edu-users/multi-select-dropdown";
import { Bounce, toast } from "react-toastify";

export const EduCompanyAdd = ({
  userType,
  forceUpdate,
  setForceUpdate,
  activateEduCompanyAdd,
  setActivateEduCompanyAdd,
}) => {
  const [companyName, setCompanyName] = useState("");
  const [description, setDescription] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      name: companyName,
      description: description,
    };

    let response;
    try {
      response = await axios(`${baseUrl}/create_company/`, {
        method: "POST",
        headers: {
          Authorization: "Token " + localStorage.getItem("token"),
        },
        data: { ...data },
      });
      if (response?.status === 201) {
        setCompanyName("");
        setDescription("");
        setActivateEduCompanyAdd(false);
        setForceUpdate(!forceUpdate);
        toast.success("Company added Successfully!!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        let unique = document.getElementById("edu-users-add-modal");
        unique.click();
      }
    } catch (error) {
      toast.error(error.response.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  return (
    <div
      className="modal fade custom-modal users-modal"
      id="add-company"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen">
        <div className="modal-content">
          <div className="modal-header justify-content-center">
            <h5 className="modal-title">Add Company</h5>
            <button
              type="button"
              className="modal-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              id="edu-users-add-modal"
            >
              <i className="fa fa-times" />
            </button>
          </div>
          <div className="modal-body">
            <div className="table modal-table">
              <div className="d-flex flex-column justify-content-center align-items-center gap-3 p-3">
                {/* Row 1 */}
                <div
                  className="w-100 d-flex flex-column flex-wrap gap-3"
                  style={{ maxWidth: "700px" }}
                >
                  <div className="flex-grow-1">
                    <label className="form-label">
                      Company Name <i className="fa fa-star fz-12" />
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Company name"
                      name="company_name"
                      onChange={(e) => setCompanyName(e.target.value)}
                      value={companyName}
                    />
                  </div>

                  <div className="flex-grow-1">
                    <label className="form-label">Description</label>
                    <textarea
                      type="text"
                      className="form-control"
                      placeholder="Write description here"
                      name="company_description"
                      onChange={(e) => setDescription(e.target.value)}
                      value={description}
                      maxLength="300"
                      rows="5"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-secondary rounded-5"
              data-bs-dismiss="modal"
              id="unique"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="thm-btn"
              data-bs-dismiss="modal"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
